var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 1.16667C5.83333 0.522334 6.35567 -3.38697e-08 7 0C7.64433 3.38701e-08 8.16667 0.522335 8.16667 1.16667V12.8333C8.16667 13.4777 7.64433 14 7 14C6.35567 14 5.83333 13.4777 5.83333 12.8333L5.83333 1.16667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 8.16667C0.522334 8.16667 5.49433e-08 7.64433 0 7C-5.49433e-08 6.35567 0.522334 5.83333 1.16667 5.83333H12.8333C13.4777 5.83333 14 6.35567 14 7C14 7.64433 13.4777 8.16667 12.8333 8.16667H1.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8c8e936dde1ea62545b54505006a3418.svg";
export { ForwardRef as ReactComponent };